<template lang="pug">
  div
    b-datepicker(icon="calendar-today" v-model="date")
      b-button.is-primary(@click="date = new Date()" icon-left="calendar-today") Сегодня
      b-button.is-danger.is-pulled-right(@click="date = null" icon-left="close") Сброс
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'datepicker',

  props: {
    value: null,
  },

  computed: {
    date: {
      get() {
        return this.value ? dayjs(this.value).toDate() : null;
      },
      set(value) {
        this.$emit('input', value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : null);
      },
    },
  },
};
</script>
